import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./FreeSpins.css";
import confetti from "canvas-confetti";
import Howlersounds from "../../../../Utillitys/slotshowlersounds"

const CongratsPopup = ({ show, FreeSpinsClosepopup, ActiveCall, muteSoundStatus }) => {
    const popupRef = useRef(null);
    const textRef = useRef(null);
    const textRefbtn = useRef(null);
    const howlerRef = useRef(null);

    const confettiStopRef = useRef(false);
    const autoCloseTimer = useRef(null);


    useEffect(() => {
        if (show) {
            howlerRef.current?.playSound("bonusWin");
            // const duration = 5000;
            // const end = Date.now() + duration;

            // Reset stop flag
            confettiStopRef.current = false;

            // Auto close after 5 seconds
            autoCloseTimer.current = setTimeout(() => {
                animationClosed();
            }, 3000);


            confetti({
                particleCount: 1000,
                spread: 180,
                startVelocity: 60,
                origin: { y: 0.7 },
                colors: ["#ffcc00", "#ff6600", "#ffffff"],
            });
            // (function frame() {
            //     if (confettiStopRef.current) return;

            //     confetti({
            //         particleCount: 10,
            //         angle: 60,
            //         spread: 100,
            //         origin: { x: 0, y: 0.8 },
            //         // colors: ["#e4bb18ff", "#d80eceff", "#ffffffff"],
            //     });
            //     confetti({
            //         particleCount: 10,
            //         angle: 120,
            //         spread: 100,
            //         origin: { x: 1, y: 0.8 },
            //         // colors: ["#d80eceff", "#e4bb18ff", "#ffffff"],
            //     });
            //     requestAnimationFrame(frame);

            //     // if (Date.now() < end) {
            //     //     requestAnimationFrame(frame);
            //     // }
            //     // Cleanup on unmount or hide
            //     return () => {
            //         confettiStopRef.current = true;
            //         clearTimeout(autoCloseTimer.current);
            //     };
            // })();


            // let count = 0;
            // const interval = setInterval(() => {
            //     confetti({
            //         particleCount: 500,
            //         spread: 180,
            //         startVelocity: 60,
            //         gravity: 1,
            //         origin: { y: 0.6 },
            //     });
            //     count++;
            //     if (count === 20) clearInterval(interval);
            // }, 300);


            // const duration = 5 * 1000; // 5 seconds
            // const end = Date.now() + duration;

            // (function frame() {
            //     confetti({
            //         particleCount: 50,
            //         startVelocity: 30,
            //         spread: 360,
            //         ticks: 60,
            //         origin: { x: Math.random(), y: Math.random() - 0.2 },
            //     });
            //     if (Date.now() < end) {
            //         requestAnimationFrame(frame);
            //     }
            // })();


            gsap.fromTo(
                popupRef.current,
                { scale: 0, opacity: 0 },
                { scale: 1, opacity: 1, duration: 0.8, ease: "back.out(1.7)" }
            );

            // Text glowing pulse animation
            gsap.fromTo(
                textRef.current,
                { scale: 1, opacity: 0.5 },
                {
                    scale: 1.1,
                    opacity: 1,
                    duration: 1.5,
                    ease: "elastic.out(1, 0.5)",
                    delay: 0.3,
                    yoyo: true,
                    repeat: -1,
                }
            );
            gsap.fromTo(
                textRefbtn.current,
                { scale: 1, opacity: 0.5 },
                {
                    scale: 1.05,
                    opacity: 1,
                    duration: 2,
                    ease: "elastic.out(1, 0.8)",
                    delay: 0.3,
                    yoyo: true,
                    repeat: -1,
                }
            );

        } else {
            gsap.to(popupRef.current, { scale: 0, opacity: 0, duration: 0.4 });
        }
    }, [show]);

    if (!show) return null;


    const CloseSpins = () => {
        confettiStopRef.current = true;       // Stop confetti immediately
        clearTimeout(autoCloseTimer.current); // Stop the auto timer
        FreeSpinsClosepopup(false);           // Close popup

        // if(show == "Bonus"){
            // BonusActiveCall(false)
        // }else{
        //     FreeSpinsClosepopup(false)
        // }
    }
    const animationClosed = () => {
        confettiStopRef.current = true;       // Stop confetti immediately
        clearTimeout(autoCloseTimer.current); // Stop the auto timer
    }
    return (
        <>
            <Howlersounds ref={howlerRef} mutesounds={muteSoundStatus} />
            <div className="popup-overlay" onClick={CloseSpins}>
                <div className="popup-container" ref={popupRef}>
                    <h1 className="popup-text" ref={textRef}>
                        🎉 Congrats! You Won
                        <span className="highlight">Bonus</span> 🎉
                        {/* <span className="highlight">10 Free Spins</span> 🎉 */}
                        <br></br>
                    </h1>
                </div>
                <div className="popup-text mar_top Click_cnt">
                    <h1 className="popup-text text_12" ref={textRefbtn} onClick={CloseSpins} >  Click to Continue</h1>
                </div>
            </div>
        </>
    );
};

export default CongratsPopup;
